import React, { useEffect, useRef, useState } from "react";
import {
  Close,
} from "../../../components/Icons/Icons";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import styles from "./Search.module.css";
import axiosClient from "../../../services/axiosClient";
import { Button, Toast } from "../../../components";
import { CameraContext } from "../../LiveCamera/LiveCamera";
import streamingClient from "../../../services/streamingClient";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import RenderStatus from "../../../components/StatusRender";
import { choseCameraPlayBack, convertArray } from "../../../utils";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles);
const Search = ({ onChange, data, onClear, fillOn, setSearchShow, refSearch, setListCodeCamera }) => {
  const { handleFullScreen, setIsSearchCam } = React.useContext(CameraContext);
  const ref = React.useRef(null);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [input, setInput] = useState();
  const [listCamera, setListCamera] = useState([]);
  const companyCode = sessionStorage.getItem('company_code');
  const refBox = useRef(null);
  const [listCameraChecked, setListCameraChecked] = useState([]);
  const { t } = useTranslation()
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  const handleClear = () => {
    if (data) {
      onClear();
      setSearch("");
      setShow(false);
    }
  };
  const onChanges = (e) => {
    const value = e.target.value;
    setInput(value);

    if (!onChange) return;
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      setSearch(value);
      if (value.trim().length > 0) {
        setShow(true);
      }
    }, 300);
  };
  const getListStatus = async (data) => {
    try {
      const filter = data.map((item) => {
        return item.CAMERA.CODE;
      });
      if (filter.length > 0) {
        const res = await streamingClient.post(
          "/streamManagement/post-state-list-camera-stream/",
          {
            list_camera_code: filter,
          }
        );
        return res.result;
      }
      return [];
    } catch (e) { }
  };
  const getListPathStreaming = async (listCam) => {
    const listCodeCam = listCam.map(item => {
      return {
        camera_code: item?.code_cam
      }
    })
    const listCamSt = listCam.map(item => {
      return {
        CAMERA: {
          CODE: item?.code_cam
        }
      }
    })
    try {
      const status = await getListStatus(listCamSt);
      const res = await streamingClient.post(
        "/streamManagement/post-list-path-streaming/",
        {
          list_camera: {
            data: listCodeCam,
          },
        }
      );
      const listStream = res?.stream.map((item) => {
        if (item.code) {
          const index = status.findIndex(
            (item_1) => item_1.camera_code === item.code
          );
          return {
            url: `${process.env.REACT_APP_BASE_URL}livestream${item.data.length > 1 ? item?.data[1].PATH : item?.data[0].PATH
              }`,
            url2: `${process.env.REACT_APP_BASE_URL}livestream${item?.data[0].PATH}`,
            isOption: false,
            name: item?.name,
            status:
              item?.data[0].STATUS === "Off"
                ? "Off"
                : status[index]?.status === 0
                  ? "On"
                  : status[index]?.status === 1
                    ? "Lose"
                    : "Weak",
            code: item.code,
          };
        }
        return null;
      });
      return listStream;
    } catch (error) {
      // throw new Error("We can't get path streaming");
    }
  };
  useEffect(() => {
    if (show && search.trim().length > 0) {
      const getData = async () => {
        try {
          const res = await axiosClient.get(
            `cameraManagement/get-list-camera/?camera_name=${search}`
          );
          const data = res.data;
          const On = res.data.filter((item) => {
            return item.CAMERA.STATUS === "On";
          });
          const status = await getListStatus(On);
          const camera = data.map((item) => {
            if (item.CAMERA.STATUS === "On") {
              const index = status.findIndex(
                (item_1) => item_1.camera_code === item.CAMERA.CODE
              );

              return {
                ...item.CAMERA,
                STATUS: status[index]?.status === 0
                  ? "On"
                  : status[index]?.status === 1
                    ? "Lose"
                    : "Weak",
              };
            }
            return item.CAMERA;
          });
          setListCamera(camera);
        } catch (error) {
          setListCamera([]);
        }
      };
      getData();
    }
  }, [show, search]);
  const onChooseCamera = async (listCam) => {
    // console.log("Oke");
    if (fillOn === "Tracing") {
      // console.log(listCam);
      const data = listCam.map((item) => ({ code: item.code_cam }))
      setListCodeCamera(data);
    }
    else if (fillOn === 'Playback') {
      let camPlaybacks = [];
      listCam?.forEach(cam => {
        let dataAdd = {
          type: 'cam',
          add: true,
          data: [{ name: cam?.name_cam, code: cam?.code_cam, status: true }],
          warehouseCode: cam?.code_wareHouse,
        }
        let listNewCam = choseCameraPlayBack([], dataAdd);
        camPlaybacks = [...camPlaybacks, ...listNewCam];
      });
      dispatch(actions.setSearchCamPlayback(camPlaybacks))
    } else {
      try {
        const data = await getListPathStreaming(listCam);
        handleFullScreen("cam", data, "Search");
        setIsSearchCam(true)
      } catch (error) {
        Toast.open(t("location.cameraIsLostConnect"), "danger");
      }
    }
    setShow(false);
  };
  useEffect(() => {
    const handleClickOutSide = (e) => {
      if (e.target === refBox.current) {
        setShow(false);
        setSearchShow(false);
      }
    };
    document.addEventListener("click", handleClickOutSide);
    return () => document.removeEventListener("click", handleClickOutSide);
  }, []);

  const handleCheckCamera = (name, code, status, wareCode) => {
    // console.log("zp");
    if (fillOn === 'AI') {
      let data = {
        path: null,
        nameCamera: name,
        nameNotification: null,
        codeCamera: code,
        time: null
      }
      // console.log(data);
      dispatch(actions.getPathNotification(data))
    } else {
      const isHaveCam = listCameraChecked.findIndex(item => item?.code_cam === code);
      if (isHaveCam >= 0 && listCameraChecked.length > 0) {
        const listCamFill = listCameraChecked.filter(item => item?.code_cam !== code);
        setListCameraChecked(listCamFill);
      } else {
        const camera = {
          name_cam: name,
          code_cam: code,
          status_cam: status,
          code_wareHouse: wareCode,
        }
        setListCameraChecked(prev => [camera, ...prev]);
      }
    }
  }

  useEffect(() => {
    if (fillOn === 'Playback') {
      const listCam = convertArray(dataStore.listCodeCamera);
      const listCameraChecked = listCam.map(item => {
        return {
          name_cam: item.name,
          code_cam: item.code,
          status_cam: null,
          code_wareHouse: null,
        }
      })
      setListCameraChecked([...listCameraChecked]);
    }
  }, [fillOn, dataStore.listCodeCamera])

  return (
    <div className={cx("content")}>
      <div id="__notification"></div>
      <input
        ref={refSearch}
        onChange={onChanges}
        value={input}
        onFocus={(e) => setShow(true)}
        className={cx("input")}
        placeholder={t("location.find")}
      />
      {data && (
        <span onClick={handleClear} className={cx("icon")}>
          <Close />
        </span>
      )}
      {show && listCamera.length > 0 && (
        <div className={cx("modal-search")} >
          <div className={cx("box-search")}>
            <div className={cx("list-camera")}>
              {listCamera.length > 0 &&
                listCamera.map((camera, index) => {
                  return (
                    <div
                      className={cx("camera-item")}
                      onClick={() => handleCheckCamera(camera.NAME_CAM, camera.CODE, camera.STATUS, camera.WAREHOUSE_CODE)}
                      key={index}
                    >
                      {fillOn !== "AI" && (
                        <input
                          type="checkbox"
                          className={cx('check_cam')}
                          checked={
                            listCameraChecked.length > 0 &&
                            listCameraChecked.findIndex(item => item?.code_cam === camera.CODE) >= 0
                          }
                        />
                      )}
                      <span className={cx("status")}>
                        <RenderStatus companyCode={companyCode} status={camera.STATUS_ACTIVE} />
                        <div className={cx("tooltip", index === 0 ? 'bottom' : 'top')}>
                          {camera.STATUS === "On"
                            ? t("location.isOnline")
                            : camera.STATUS === "Off"
                              ? t("location.isOffline")
                              : camera.STATUS === "Lose"
                                ? t("location.isLostConnect")
                                : t("location.isWeek")}
                        </div>
                      </span>
                      <div className={cx("name-camera")}>{camera.NAME_CAM}</div>
                    </div>
                  );
                })}
            </div>
          </div>
          {fillOn !== "AI" && listCameraChecked?.length > 0 && listCamera.length > 0 && (
            <div className={cx('submit-btn')}>
              <Button onClick={() => onChooseCamera(listCameraChecked)} title={t("location.seenCam")} />
            </div>
          )}
        </div>
      )}
      {show && <div className={cx('bg-box')} ref={refBox}></div>}
    </div>
  );
};
Search.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.string,
  onClear: PropTypes.func,
};
export default React.memo(Search);
